import styled from 'styled-components'

import { Typography } from '../../../components/atoms'

export const Title = styled(Typography)`
  padding: 24px;
  && {
    font-family: Roboto;
    font-size: ${props => props.theme.v2.typography.fontSize.large};
    font-style: normal;
    font-weight: 700;
    line-height: 21px;
    letter-spacing: 0em;
    text-align: left;
    color: ${props => props.theme.v2.palette.grayScale['80']};
  }
`

export const CellTitle = styled(Typography)`
  && {
    font-size: ${props => props.theme.v2.typography.fontSize.medium};
    font-weight: bold;
  }
`

export const NoResultsFound = styled.p`
  margin-top: 100px;
  font-size: ${props => props.theme.v2.typography.fontSize.medium};
  color: ${props => props.theme.v2.palette.grayScale['40']};
`

export const Header = styled.div`
  && {
    align-items: center;
    padding: 0 24px 24px 24px;
  }
`

export const Content = styled.div`
  && {
    align-items: center;
    padding: 0 24px 24px 24px;
  }
`

export const HeaderTitle = styled(Typography)`
  && {
    font-size: ${props => props.theme.v2.typography.fontSize.small};
    color: ${props => props.theme.v2.palette.primary.darker};
    font-weight: bold;
  }
`
